import {
  Rating as MuiRating,
  type RatingProps as MuiRatingProps,
} from '@mui/material';

export type RatingProps = MuiRatingProps;

export const Rating = (props: RatingProps) => (
  <MuiRating data-testid="rating" {...props} />
);
